import { useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Send, Mail } from "lucide-react";

export default function ContactTab() {
  const { t } = useLang();
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success(t("contact_sent"));
      setF({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ss-rise max-w-xl">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mb-1">{t("contact_title")}</h1>
      <p className="text-muted-foreground text-sm mb-6 flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {t("contact_intro")}</p>
      <form onSubmit={submit} className="space-y-4 p-5 rounded-2xl border border-border bg-card" data-testid="contact-form">
        <div>
          <Label className="text-xs">{t("contact_name")}</Label>
          <Input data-testid="contact-name" required value={f.name} onChange={upd("name")} className="mt-1 bg-secondary/50" />
        </div>
        <div>
          <Label className="text-xs">{t("contact_email")}</Label>
          <Input data-testid="contact-email" required type="email" value={f.email} onChange={upd("email")} className="mt-1 bg-secondary/50" />
        </div>
        <div>
          <Label className="text-xs">{t("contact_message")}</Label>
          <Textarea data-testid="contact-message" required rows={5} value={f.message} onChange={upd("message")} className="mt-1 bg-secondary/50" />
        </div>
        <Button data-testid="contact-send-btn" type="submit" disabled={busy} className="w-full h-11 rounded-xl bg-primary hover:bg-primary/90 font-semibold">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-2" /> {t("contact_send")}</>}
        </Button>
      </form>
    </div>
  );
}
